import { z } from 'zod';

import { createZodNumberLike } from '@Common/types/zod/zod-number-like';
import { ZodLimitQuery, ZodOffsetQuery } from '@Common/types/zod/zod-number-query';
import { createZodParamsValidator } from '@Common/types/zod/zod-params';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodPaginationQueryObject = z.object({
  offset: ZodOffsetQuery,
  limit: ZodLimitQuery,
});

export const ZodPaginationQuery = createZodParamsValidator(ZodPaginationQueryObject);

export type PaginationQuery = z.infer<typeof ZodPaginationQuery>;

export const ZodOptionalPaginationQueryObject = z.object({
  offset: ZodOffsetQuery.optional(),
  limit: ZodLimitQuery.optional(),
});

export const ZodOptionalPaginationQuery = createZodParamsValidator(
  ZodOptionalPaginationQueryObject,
);

export type OptionalPaginationQuery = z.infer<typeof ZodOptionalPaginationQuery>;

export const ZodId = createZodNumberLike(z.number().int().safe());
export const ZodIDPathParam = createZodParamsValidator(
  z.object({
    id: ZodId,
  }),
);

export type IdPathParam = z.infer<typeof ZodIDPathParam>;

export const ZodStringIDPathParam = createZodParamsValidator(
  z.object({
    id: ZodTrimmedString,
  }),
);
export type StringIdPathParam = z.infer<typeof ZodStringIDPathParam>;

export const ZodCursorQuery = createZodParamsValidator(
  z.object({
    limit: ZodLimitQuery,
    cursor: ZodTrimmedString.optional(),
    direction: z.enum(['asc', 'desc']).optional(),
    include_current: z.boolean().optional(),
  }),
);
export type CursorQuery = z.infer<typeof ZodCursorQuery>;

export const ZodForceSMSHeaders = z.object({
  'force-sms': ZodTrimmedString.optional(),
});

export const ZodUserAgentHeaders = z.object({
  'user-agent': ZodTrimmedString.optional(),
});
